import { render, staticRenderFns } from "./UserCounter.vue?vue&type=template&id=0a65362c"
import script from "./UserCounter.vue?vue&type=script&lang=js"
export * from "./UserCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports